import { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Box,
  Button
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { completeOrReschedulePayment } from 'src/api';
import { CONSTANTS, STRINGS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { commonReducerAction } from 'src/redux/reducers/common';

const PendingPayments = ({ data }) => {
  const dispatch = useDispatch();
  const { startLoading, stopLoading } = loaderReducerAction;
  const { logoutUser } = commonReducerAction;
  const { user } = useSelector((state) => state.common);
  const [page, setPage] = useState(0);
  const headers = ['Title', 'Body', '', ''];
  const limit = 20;

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  const handleCompleteCick = (item) => {
    const dataToSend = {
      query_id: item._id,
      is_complete_query: true
    };
    dispatch(startLoading());
    completeOrReschedulePayment(user, dataToSend)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
          dispatch(logoutUser());
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          // setDashboardData(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => dispatch(stopLoading()));
  };

  const handleRescheduleCick = (item) => {
    const dataToSend = {
      query_id: item._id,
      reschedule_date: true
    };
    dispatch(startLoading());
    completeOrReschedulePayment(user, dataToSend)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
          dispatch(logoutUser());
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          // setDashboardData(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => dispatch(stopLoading()));
  };

  return (
    <>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell key={index}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(0, limit)?.length ? (
                data.slice(0, limit).map((dataItem, index) => (
                  <TableRow hover key={index}>
                    <TableCell>{dataItem.notification_title}</TableCell>
                    <TableCell>{dataItem.notification_body}</TableCell>
                    <TableCell>
                      <Button
                        color="primary"
                        size="medium"
                        type="submit"
                        variant="contained"
                        onClick={() => handleCompleteCick(dataItem)}
                      >
                        {STRINGS.COMPLETE}
                      </Button>
                    </TableCell>
                    <TableCell>
                      <Button
                        color="primary"
                        size="medium"
                        type="submit"
                        variant="contained"
                        onClick={() => handleRescheduleCick(dataItem)}
                      >
                        {STRINGS.RESCHEDULE}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow hover>
                  <TableCell
                    colSpan={headers.length}
                    style={{ textAlign: 'center' }}
                  >
                    {STRINGS.NO_NOTIFICATIONS_FOUND}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      {data?.length ? (
        <TablePagination
          component="div"
          count={data?.length}
          onPageChange={handlePageChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[]}
        />
      ) : null}
    </>
  );
};

export default PendingPayments;
